import { gitlabAuthApiRef } from '@backstage/core-plugin-api';
import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { ScmAuth, scmAuthApiRef } from '@backstage/integration-react';

// Nothing in @backstage/frontend-defaults provides scmAuthApiRef, so without this
// module the app has no ScmAuth implementation at all and a RepoUrlPicker that
// sets `requestUserCredentials` cannot obtain a token.
//
// `ScmAuth.createDefaultApiFactory()` would not help either: it covers github.com,
// gitlab.com, dev.azure.com and bitbucket.org, and git.eon-cds.de — the only SCM
// integration this app has — matches none of them. Hence forGitlab with an
// explicit host.
//
// Scopes requested: `read_user read_api read_repository`, plus `write_repository
// api` when a caller asks for repoWrite. All of them must be registered on the
// `iPEN Workbench` OAuth application or GitLab answers `invalid_scope`.
const scmAuthApi = ApiBlueprint.make({
  name: 'scm-auth',
  params: defineParams =>
    defineParams({
      api: scmAuthApiRef,
      deps: {
        gitlabAuthApi: gitlabAuthApiRef,
      },
      factory: ({ gitlabAuthApi }) =>
        ScmAuth.forGitlab(gitlabAuthApi, { host: 'git.eon-cds.de' }),
    }),
});

export const scmAuthModule = createFrontendModule({
  pluginId: 'scm-auth',
  extensions: [scmAuthApi],
});
